module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "board-header",
    attrs: {
      "role": "banner",
      "aria-label": "Header dashboard"
    }
  }, [_c('h1', {
    staticClass: "dashboard-title"
  }, [_vm._v("Tableau de bord")]), _vm._v(" "), _c('span', {
    staticClass: "dashboard-subtitle"
  }, [_vm._v("Gérez vos prospects et suivez vos clients.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d693bba4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Board/BoardHeader.vue
// module id = 1176
// module chunks = 0